module.exports = __webpack_public_path__ + "img/perfil.b4eaec28.svg";